import { Component, inject, Input } from '@angular/core'
import { CellLabelComponent } from '@app/feature/input-cells/cell-label/cell-label.component'
import { InputCellContainerComponent } from '@app/feature/input-cells/input-cell-container/input-cell-container.component'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import {
    CellEntities,
    FieldEntities,
    FieldType,
    Workspace,
    ViewConfigurationSettings,
} from '@core/models'
import { Dictionary } from '@ngrx/entity'
import {
    CellContainerComponent,
    NEW_CONTAINER_CELLS,
} from '../../../shared/cell-types/cell-container.component'
import { FieldTypeFactoryService } from '@services/factories/field-type/field-type-factory.service'

@Component({
    selector: 'app-board-card-fields',
    templateUrl: './board-card-fields.component.html',
    styleUrls: ['./board-card-fields.component.sass'],
    imports: [
        CellContainerComponent,
        InputCellContainerComponent,
        CellLabelComponent,
        TbIconComponent,
    ],
})
export class BoardCardFieldsComponent {
    private readonly fieldTypeFactoryService = inject(FieldTypeFactoryService)

    @Input()
    fields?: string[]

    @Input()
    fieldEntities!: FieldEntities

    @Input()
    fieldTypes!: Dictionary<FieldType>

    @Input()
    selectedWorkspace!: Workspace | undefined

    @Input()
    cells!: CellEntities

    @Input()
    configurationSettings?: ViewConfigurationSettings

    hasNewContainerSupport(type: string) {
        return NEW_CONTAINER_CELLS.includes(type)
    }

    getIconByFieldType(fieldTypeGuid: string) {
        return this.fieldTypeFactoryService.getIconByFieldType(fieldTypeGuid)
    }
}
